import { Color, CylinderGeometry, Mesh, ShaderMaterial, use } from '@anov/3d-core'
import type { SceneControl } from '@anov/3d-core'
import type { ModelOption as LinkOption } from '../types'
import CylinderShader from '../shader/cylinder'
import LinkMesh from '.'

class CylinderMesh extends LinkMesh {
  private _color: string
  private _material: ShaderMaterial

  public get color(): string {
    return this._color
  }

  public set color(newValue: string) {
    if (this._color === newValue)
      return
    this._color = newValue
    this._material.uniforms.color.value = new Color(this._color)
  }

  constructor(option: LinkOption, sceneControl: SceneControl) {
    super(sceneControl)
    const { color } = option
    this._color = color
    this._readyPromise = this.init()
  }

  dispose() {
    this.remove(this._mesh)
  }

  private async init() {
    this._mesh = this.getCylinder()
    this.add(this._mesh)
    return true
  }

  // 场景初始化部分同上，这里主要展示Shader部分
  private getCylinder() {
    const radius = 0.01
    const height = 1.5
    const segments = 32

    const geometry = new CylinderGeometry(radius, radius, height, segments)

    const { uniforms, vertexShader, fragmentShader } = CylinderShader
    this._material = new ShaderMaterial({
      uniforms,
      vertexShader,
      fragmentShader,
    })

    const mesh = new Mesh(geometry, this._material)
    use.useframe(this.sceneControl, () => {
      this._material.uniforms.uTime.value = performance.now() / 1000
    })
    // mesh.rotation.order = 'YXZ' // 设置旋转顺序
    return mesh
  }
}

export default CylinderMesh